import { useBoolean } from 'react-use';
import { toast } from 'react-toastify';
import { useMoveCaseToNextStatusMutation } from '@/queries/case';
import { retrieveUnifiedError } from '@/api/utils';
import { CaseStatus } from '@/api/apis/case';

export const useUpdateCaseStatus = () => {
  const [isSubmitting, setIsSubmitting] = useBoolean(false);
  const { mutateAsync: mutateCaseStatus } = useMoveCaseToNextStatusMutation();

  const updateStatus = async (caseId: string, nextStatus: CaseStatus) => {
    try {
      setIsSubmitting(true);
      await mutateCaseStatus({ caseId, nextStatus });

      toast.success('Status successfully updated');
    } catch (error) {
      const { message } = retrieveUnifiedError(error);
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };
  return { updateStatus, isSubmitting };
};
